import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function useCsvImport() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!location.state?.openCsvImport) return;
    setOpen(true);
    const state = { ...location.state };
    delete state.openCsvImport;
    navigate(`${location.pathname}${location.search}${location.hash}`, { replace: true, state });
  }, [location, navigate]);
  return [open, setOpen];
}
